import './Render.css'

const UserRender = ({record}) => {
    return (
        <div className='render'>
            <p><b>Uživatelské jméno:</b> {record.name}</p>
            <p><b>Role:</b> {record.role.name}</p>
        </div>
    )
}

export default UserRender